import { render, staticRenderFns } from "./BDcyTable.vue?vue&type=template&id=58633211&scoped=true"
import script from "./BDcyTable.vue?vue&type=script&lang=js"
export * from "./BDcyTable.vue?vue&type=script&lang=js"
import style0 from "./BDcyTable.vue?vue&type=style&index=0&id=58633211&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58633211",
  null
  
)

export default component.exports